import { gql } from '@apollo/client'
import type { FilterQuery, PurchaseOrder } from '@ztechapps/common.contract'

const query = gql`
  query allPurchaseOrder($filter: JSON!, $options: JSON) {
    allPurchaseOrder(filter: $filter, options: $options) {
      _id
      code
      purchaseDate
      status
      vendor {
        _id
        company {
          _id
          name
        }
        profile {
          _id
          email
          name
        }
      }
    }
  }
`

export const usePurchaseOrderSelect = () => {
  const dataLoadOptions = ({ filter }: FilterQuery<PurchaseOrder>) => ({
    query: query,
    filter: ({ input }: any) => {
      const result = {
        $or: [
          { code: { $regex: input, $options: 'i' } },
          { 'vendor.profile.name': { $regex: input, $options: 'i' } },
          {
            'vendor.profile.email': {
              $regex: input,
              $options: 'i',
            },
          },
          {
            'vendor.company.name': {
              $regex: input,
              $options: 'i',
            },
          },
        ],
        ...filter,
      }
      return result
    },
    options: () => ({
      sort: { createdAt: -1 as const },
    }),
    resultFieldName: 'allPurchaseOrder',
  })

  return { dataLoadOptions }
}
